import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { EProductType, IProduct } from 'src/app/models/product.model';
import { ToastService } from 'src/app/services/toast.service';
import { environment } from 'src/environments/environment';
import { cloneDeep } from 'lodash-es';

@Component({
  selector: 'app-manage-product-dialog',
  templateUrl: './manage-product-dialog.component.html',
  styleUrl: './manage-product-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ManageProductDialogComponent implements OnInit {
  @ViewChild('fileInput') fileInput: any;

  @Input() editMode = false;
  @Input() productToEdit: IProduct = null;
  @Input() selectedImage: string = null;

  @Output() onSaveProduct = new EventEmitter<IProduct>();
  @Output() closeDialog = new EventEmitter<boolean>();

  public EProductType = EProductType;

  public dragEvent = false;
  public environment = environment;
  public product = {} as IProduct;

  public imageLoading = false;
  public showLoadingSpinnerInButton = false;

  constructor(private toastService: ToastService) {}

  async ngOnInit() {
    if (this.editMode) {
      this.product = cloneDeep(this.productToEdit);
    }
  }

  public saveProduct(): void {
    if (this.showLoadingSpinnerInButton) return;
    if (
      !this.product.title ||
      !this.product.image ||
      !this.product.price ||
      !this.product.description ||
      !this.product.type
    ) {
      this.toastService.error('Please add all product information');
      return;
    }

    // removes the image from the product if it hasn't changed to avoid overwriting in backend
    if (this.editMode && this.productToEdit.image === this.product.image) {
      delete this.product.image;
    }
    this.showLoadingSpinnerInButton = true;
    this.onSaveProduct.emit(this.product);
  }
  public onCloseDialog(): void {
    this.product = null;
    this.closeDialog.emit(true);
  }

  public getProductTypes(): EProductType[] {
    return Object.values(EProductType);
  }

  public onSelectProductType(productType: EProductType): void {
    this.product.type = productType;
  }

  public triggerFileInput(): void {
    this.fileInput.nativeElement.click();
  }

  public onFileSelected(event: any): void {
    const file = event.target.files[0];
    this.setSelectedImage(file);
  }

  public onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.dragEvent = true;
  }

  public onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.dragEvent = false;
  }

  public onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.dragEvent = false;
    const file = event.dataTransfer?.files[0];
    if (file) this.setSelectedImage(file);
  }

  private setSelectedImage(file: File): void {
    this.product.image = file;

    const reader = new FileReader();
    reader.onload = (e: any) => {
      const base64String = reader.result as string;
      this.selectedImage = base64String;
    };
    reader.readAsDataURL(file);
  }
}
